/**
 * Single source of truth for all translations.
 * Edit `translations/all-translations.json` to add or change any translation key.
 * Structure: { [section]: { [key]: { [langCode]: value } } } — keys may nest
 * further (`profile.validation.nameRequired`). A leaf without the current
 * language falls back to English (LanguageContext `translate`).
 */
import allTranslations from './translations/all-translations.json'

export type LangCode = 'en' | 'hi' | 'es' | 'fr' | 'de' | 'zh' | 'ja' | 'ko' | 'ar' | 'pt' | 'ru' | 'it'

export const TRANSLATIONS = allTranslations as unknown as Record<string, Record<string, unknown>>

